import React, { createContext, useState } from "react";

export const CharacterContext = createContext(); 

export const CharacterProvider = ({ children }) => {
  const [characters, setCharacters] = useState([{name:"None", age:'na', gender:'na', ethnicity:'na', hair:'na', clothing:'na', featuresToAvoid:'na', image:'na', imageId:'na'}])

  return (
    <CharacterContext.Provider value={{ characters, setCharacters }}>
      {children} 
    </CharacterContext.Provider>
  );
};
